export default "__VITE_ASSET__DpHLl8up__"